define("shared/components/shared/ui/social-set-switcher/list", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@ember/utils", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _utils, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--dropWrapper tPA--profile--dropWrapper qa--profileSwitcher_dropdown" ...attributes>
    <div class="o--dropBody">
  
      <ul class="o--dropBody__list o--page__switcherDrop">
  
        {{#each @switchableSets as |identity|}}
          <li class="o--dropBody__item qa--profileSwitcher_social_set_option">
  
            <Shared::Ui::Button
              @onClick={{fn @selectSocialSet identity.socialIdentity}}
              @variant="unstyled"
              class="o--dropBody__link"
            >
              <Shared::Ui::SocialSetSwitcher::SocialSet
                @index={{rebase-indexed-number identity.index}}
                @isMobile={{@isMobile}}
                @isSelected={{eq @selectedSocialSet identity.socialIdentity}}
                @shouldHaveLabel={{true}}
                @socialIdentity={{identity.socialIdentity}}
              />
            </Shared::Ui::Button>
  
          </li>
        {{/each}}
        {{#if this.hasUnswitchableSets}}
          <hr class="u--m__b__xs" />
          <span class="u--text--sm u--text--light u--p__l__sm">
            {{t "shared_phrases.not_available"}}
          </span>
          <hr class="u--m__t__xs" />
          {{#each @unswitchableSets as |identity|}}
            <li class="o--dropBody__item is--disabled">
  
              <Shared::Ui::Button @isDisabled={{true}} @variant="unstyled" class="o--dropBody__link">
                <Shared::Ui::SocialSetSwitcher::SocialSet
                  @index={{rebase-indexed-number identity.index}}
                  @isMobile={{@isMobile}}
                  @isSelected={{false}}
                  @shouldHaveLabel={{true}}
                  @socialIdentity={{identity.socialIdentity}}
                  class="u--mute"
                />
              </Shared::Ui::Button>
  
            </li>
          {{/each}}
        {{/if}}
        {{#if this.hasNoSets}}
          <div class="o--blank u--p__tb__md">
            <p class="o--blank__title">{{t "shared_phrases.no_other_social_sets"}}</p>
          </div>
        {{/if}}
  
      </ul>
  
    </div>
  </div>
  */
  {
    "id": "UCycAFgZ",
    "block": "[[[11,0],[24,0,\"o--dropWrapper tPA--profile--dropWrapper qa--profileSwitcher_dropdown\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n\\n    \"],[10,\"ul\"],[14,0,\"o--dropBody__list o--page__switcherDrop\"],[12],[1,\"\\n\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,2]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"o--dropBody__item qa--profileSwitcher_social_set_option\"],[12],[1,\"\\n\\n          \"],[8,[39,2],[[24,0,\"o--dropBody__link\"]],[[\"@onClick\",\"@variant\"],[[28,[37,3],[[30,4],[30,3,[\"socialIdentity\"]]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[8,[39,4],null,[[\"@index\",\"@isMobile\",\"@isSelected\",\"@shouldHaveLabel\",\"@socialIdentity\"],[[28,[37,5],[[30,3,[\"index\"]]],null],[30,5],[28,[37,6],[[30,6],[30,3,[\"socialIdentity\"]]],null],true,[30,3,[\"socialIdentity\"]]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\\n        \"],[13],[1,\"\\n\"]],[3]],null],[41,[30,0,[\"hasUnswitchableSets\"]],[[[1,\"        \"],[10,\"hr\"],[14,0,\"u--m__b__xs\"],[12],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--sm u--text--light u--p__l__sm\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"shared_phrases.not_available\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"hr\"],[14,0,\"u--m__t__xs\"],[12],[13],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,7]],null]],null],null,[[[1,\"          \"],[10,\"li\"],[14,0,\"o--dropBody__item is--disabled\"],[12],[1,\"\\n\\n            \"],[8,[39,2],[[24,0,\"o--dropBody__link\"]],[[\"@isDisabled\",\"@variant\"],[true,\"unstyled\"]],[[\"default\"],[[[[1,\"\\n              \"],[8,[39,4],[[24,0,\"u--mute\"]],[[\"@index\",\"@isMobile\",\"@isSelected\",\"@shouldHaveLabel\",\"@socialIdentity\"],[[28,[37,5],[[30,8,[\"index\"]]],null],[30,5],false,true,[30,8,[\"socialIdentity\"]]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n\\n          \"],[13],[1,\"\\n\"]],[8]],null]],[]],null],[41,[30,0,[\"hasNoSets\"]],[[[1,\"        \"],[10,0],[14,0,\"o--blank u--p__tb__md\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"o--blank__title\"],[12],[1,[28,[35,8],[\"shared_phrases.no_other_social_sets\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@switchableSets\",\"identity\",\"@selectSocialSet\",\"@isMobile\",\"@selectedSocialSet\",\"@unswitchableSets\",\"identity\"],false,[\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"shared/ui/social-set-switcher/social-set\",\"rebase-indexed-number\",\"eq\",\"if\",\"t\"]]",
    "moduleName": "shared/components/shared/ui/social-set-switcher/list.hbs",
    "isStrictMode": false
  });

  let ListComponent = (_class = class ListComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);
    }

    get hasUnswitchableSets() {
      return this.args.unswitchableSets?.length > 0;
    }

    get hasUpgradableSets() {
      return this.args.upgradableSets && this.args.upgradableSets.length > 0 ? true : false;
    }

    get hasNoSets() {
      return !this.args.switchableSets.length && !this.hasUnswitchableSets && !this.hasUpgradableSets;
    }

    get upgradeText() {
      return (0, _utils.isPresent)(this.args.upgradeText) ? this.args.upgradeText : this.intl.t('shared_phrases.available_for_paid_plans');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = ListComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListComponent);
});